var TastyBurgerButton = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('button', { staticClass: "hamburger", class: [_vm.isActive ? 'is-active' : '', _vm.burgerTypeClass], attrs: { "type": "button" }, on: { "click": function click($event) {
          $event.preventDefault();return _vm.toggle($event);
        } } }, [_c('span', { staticClass: "hamburger-box", style: _vm.buttonStyle }, [_c('span', { staticClass: "hamburger-inner", style: _vm.layerStyle }, [_c('span', { staticClass: "hamburger-inner__before", style: _vm.layerStyle }), _vm._v(" "), _c('span', { staticClass: "hamburger-inner__after", style: _vm.layerStyle })])])]);
  }, staticRenderFns: [],
  props: {
    type: {
      type: String,
      default: 'boring'
    },
    active: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#000000'
    },
    activeColor: {
      type: String,
      default: '#000000'
    },
    size: {
      type: String,
      validator: function validator(value) {
        return ['xs', 's', 'm', 'l', 'xl'].indexOf(value) !== -1;
      },
      default: 'm'
    }
  },

  data: function data() {
    return {
      burgerTypeClass: null,
      isActive: null
    };
  },


  created: function created() {
    this.burgerTypeClass = 'hamburger--' + this.type;
    this.isActive = this.active;

    switch (this.size) {
      case 'xs':
        this.buttonStyle = {
          transform: 'scale(0.5)',
          width: '20px',
          height: '13px'
        };
        break;
      case 's':
        this.buttonStyle = {
          transform: 'scale(0.7)',
          width: '29px',
          height: '18px'
        };
        break;
      case 'm':
        this.buttonStyle = {
          transform: 'scale(0.9)',
          width: '36px',
          height: '23px'
        };
        break;
      case 'l':
        this.buttonStyle = {
          transform: 'scale(1.1)',
          width: '44px',
          height: '27px'
        };
        break;
      case 'xl':
        this.buttonStyle = {
          transform: 'scale(1.3)',
          width: '52px',
          height: '32px'
        };
        break;
    }
  },

  computed: {
    layerStyle: function layerStyle() {
      return {
        'background-color': this.isActive ? this.activeColor : this.color
      };
    }
  },

  methods: {
    toggle: function toggle(e) {
      this.isActive = !this.isActive;
      this.$emit('toggle', this.isActive);
    }
  }
};

function install(Vue, options) {
  Vue.component('tasty-burger-button', TastyBurgerButton);
  var key = 'tasty-burger-button';
  key = options && options.prefix ? options.prefix + '-' + key : key;
  Vue.component(key, TastyBurgerButton);
}

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use({ install: install });
}

export { install, TastyBurgerButton };
//# sourceMappingURL=vue-tasty-burgers.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-tasty-burgers/dist/vue-tasty-burgers.js
// module id = CXew
// module chunks = 1